import(/* webpackMode: "eager" */ "/home/runner/work/MONADATY/MONADATY/app/not-found.tsx");
